import React, { useState, useEffect } from "react";
import "../styles/SettingsSection.css";
import ToggleTheme from "./ToggleTheme";
import AudioSettings from "./AudioSettings"; // Import AudioSettings component
import "../styles/AudioSettings.css";
import font_size_small from "../images/font_size_small.svg";
import font_size_big from "../images/font_size_big.svg";
import { speakText, enableSpeech, disableSpeech } from "./utils/speechUtils"; // Import speakText, enableSpeech, and disableSpeech

const VolumeSlider = ({ value, onChange }) => {
  return (
    <div className="settings-slider-container">
      {/* Volume decrease icon */}
      <img
        src={font_size_small}
        alt="Volume decrease"
        className="settings-volume-icon"
      />

      {/* Slider input */}
      <div className="slider-container">
        <input
          type="range"
          min="0"
          max="100"
          value={value}
          className="slider"
          onChange={(e) => onChange(Number(e.target.value))}
          onFocus={() => speakText("Text Size Slider")} // Speak on focus
        />
      </div>

      {/* Volume increase icon */}
      <img
        src={font_size_big}
        alt="Volume increase"
        className="settings-volume-icon"
      />
    </div>
  );
};

const SettingsSection = () => {
  const [volume, setVolume] = useState(50); // Initial volume state
const [isAudioModeOn, setIsAudioModeOn] = useState(() => {
  // Retrieve initial state from localStorage
  const savedState = localStorage.getItem("isAudioModeOn");
  // Default to false for new sessions/logins
  return savedState !== null ? JSON.parse(savedState) : false;
});


  useEffect(() => {
    // Persist state to localStorage whenever it changes
    localStorage.setItem("isAudioModeOn", JSON.stringify(isAudioModeOn));
    if (isAudioModeOn) {
      enableSpeech(); // Enable speech
    } else {
      disableSpeech(); // Disable speech
    }
  }, [isAudioModeOn]);

  const handleAudioModeToggle = () => {
    setIsAudioModeOn((prev) => !prev);
  };

  const handleNotifToggle = (id) => {
    setNotificationSettings((prevSettings) =>
      prevSettings.map((setting) =>
        setting.id === id
          ? { ...setting, isActive: !setting.isActive }
          : setting
      )
    );
  };

  const [notificationSettings, setNotificationSettings] = useState([
    {
      id: "newsUpdates",
      label: "News and Updates",
      ariaLabel: "Toggle news and updates notifications",
      isActive: false, // Initial state
    },
    {
      id: "newBooks",
      label: "New Book Release",
      ariaLabel: "Toggle new book release notifications",
      isActive: true, // Initial state
    },
  ]);

  const handleTabClick = (tabName) => {
    speakText(tabName); // Speak the tab name
  };

  return (
    <div className="settings-section">
      <section className="settings-content">
        <h1
          className="settings-heading"
          onClick={() => handleTabClick("Display Settings")}
        >
          Display Settings
        </h1>

        <form className="settings-form">
          <div className="settings-form-group">
            <label htmlFor="themeSelect">Select Theme</label>
            <ToggleTheme onFocus={() => speakText("Select Theme")} />{" "}
            {/* Speak on focus */}
          </div>

          <div className="settings-form-group">
            <label htmlFor="textSize">Text Size</label>
            {/* VolumeSlider component */}
            <VolumeSlider value={volume} onChange={setVolume} />
          </div>
        </form>
        <h2
          className="settings-audio-settings"
          onClick={() => handleTabClick("Audio Settings")}
        >
          Audio Settings
        </h2>

        <AudioSettings />
      </section>

      <section className="notif-container">
        <h1
          className="notif-heading"
          onClick={() => handleTabClick("Notification Settings")}
        >
          Notification Settings
        </h1>

        <div className="notif-settingsGroup">
          {notificationSettings.map((setting) => (
            <div key={setting.id} className="notif-settingItem">
              <label className="notif-settingLabel" htmlFor={setting.id}>
                {setting.label}
              </label>

              <div className="audio-settings-toggle">
                <div
                  className={`audio-toggle ${setting.isActive ? "active" : ""}`}
                  onClick={() => handleNotifToggle(setting.id)}
                  role="switch"
                  aria-checked={setting.isActive}
                  aria-label={setting.ariaLabel}
                  id={setting.id}
                >
                  <div className="audio-toggle-knob"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Audio Mode Toggle */}
        <div className="audio-mode-container">
          <h2 className="audio-mode-heading">Audio Mode</h2>
          <div
            className={`audio-toggle ${isAudioModeOn ? "active" : ""}`}
            onClick={handleAudioModeToggle}
            role="switch"
            aria-checked={isAudioModeOn}
            aria-label="Toggle Audio Mode"
          >
            <div className="audio-toggle-knob"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SettingsSection;
